<template>
  <div>
    <v-card color="#F6F8FC" flat class="px-3">
      <v-form v-model="valid" class="py-2">
      

        <v-container class="mt-2 text_feild_text">
           
          <v-text-field 
          
            v-model="firstname"
            label="First name"
            required
          ></v-text-field>
          <v-text-field
            v-model="lastname"
            label="Last name"
            required
          ></v-text-field>
             <v-text-field
            v-model="address"
            label="Address"
            required
          ></v-text-field>
           <v-text-field
            v-model="city"
            label="City"
            required
          ></v-text-field>
          <v-text-field
            v-model="zipcode"
            label="Zip Code"
            required
          ></v-text-field>
          <v-text-field
            v-model="country"
            label="Country"
            required
          ></v-text-field>
          <v-text-field
            v-model="state"
            label="State"
            required
          ></v-text-field>
           <v-text-field
            v-model="PhoneNumber"
            label="Phone Number"
            required
          ></v-text-field>

          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="Email address"
            required
          ></v-text-field>
        </v-container>
      </v-form>
    </v-card>
  </div>
</template>

<script>
// import VueDropify from "vue-dropify";
// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  name: "editteamcomponent",
  components: {
    // VueDropify,
    // vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200, 
        addRemoveLinks: true,
      },
      valid: false,
      firstname: "",
      lastname: "",
      address:"",
      city:"",
      zipcode:"",
      country:"",
      state:"",
      PhoneNumber: "",
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      role: ["super admin", "admin"],
    };
  },
  methods: {},
};
</script>

<style scoped>
.vue-dropzone {
    padding: 0;
    background: transparent;
    border-style: dashed;
}
.text_feild_text
{
  font-family: 'DM Sans';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 21px;
color: #121212;
}
</style>


